import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Language from "@mui/icons-material/Language";
import FormLabel from "@mui/joy/FormLabel";
import Radio, { radioClasses } from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import Sheet from "@mui/joy/Sheet";
import React from "react";

interface AsciiArtFooterProps {
  handleRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  currentlySelectedRadio: string;
  defaultDensityMappingName: string;
}

export default function AsciiArtFooter({
  handleRadioChange,
  currentlySelectedRadio,
  defaultDensityMappingName,
}: AsciiArtFooterProps) {
  return (
    <footer className="absolute bottom-4 w-full">
      <IconsRadio
        handleChange={handleRadioChange}
        defaultDensityMappingName={defaultDensityMappingName}
        currentlySelectedRadio={currentlySelectedRadio}
      />
    </footer>
  );
}

const RADIO_BUTTONS = [
  {
    id: "codingTrain",
    title: "English",
    icon: <Language sx={{ zIndex: 2 }} fontSize="large" />,
  },
  {
    id: 'farsiCustom',
    title: 'Farsi Subset',
    icon: (<Language sx={{zIndex: 2}} fontSize="large" />),
  },
  {
    id: "farsiAlphabet",
    title: "Farsi Alphabet",
    icon: <Language sx={{ zIndex: 2 }} fontSize="large" />,
  },
];

interface IconsRadioProps {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  currentlySelectedRadio: string;
  defaultDensityMappingName: string;
}

function IconsRadio({ handleChange, currentlySelectedRadio, defaultDensityMappingName }: IconsRadioProps) {
  return (
    <RadioGroup
      onChange={handleChange}
      aria-label="alphabet"
      defaultValue={defaultDensityMappingName}
      overlay
      name="alphabet"
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        [`& .${radioClasses.checked}`]: {
          [`& .${radioClasses.action}`]: {
            inset: -1,
            border: "3px solid",
            borderColor: "primary.500",
            bgcolor: "primary.500",
          },
        },
        [`& .${radioClasses.radio}`]: {
          display: "contents",
          "& > svg": {
            zIndex: 2,
            position: "absolute",
            top: "-8px",
            right: "-8px",
            bgcolor: "background.surface",
            borderRadius: "50%",
          },
        },
      }}
    >
      {RADIO_BUTTONS.map((button) => (
        <Sheet
          key={button.title}
          variant="outlined"
          sx={{
            borderRadius: "md",
            boxShadow: "sm",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
            paddingBottom: 2,
            minWidth: 120,
            color: currentlySelectedRadio === button.id ? "white" : "inherit",
          }}
        >
          <Radio
            id={button.title}
            value={button.id}
            checkedIcon={<CheckCircleRoundedIcon />}
          />
          {button.icon}
          <FormLabel
            sx={{
              zIndex: 2,
              color: currentlySelectedRadio === button.id ? "white" : "inherit",
            }}
            htmlFor={button.title}
          >
            {button.title}
          </FormLabel>
        </Sheet>
      ))}
    </RadioGroup>
  );
}
